export default __webpack_public_path__ + "static/media/Warning.7896f857.svg";